import "./OurGlobalReach.module.css";
import Navigation from "@/reusable_sections/Header";
import Network from "./sections/Network";
import SupplyChain from "./sections/SupplyChain";
import Logistics from "./sections/Logistics";
import Footer from "@/reusable_sections/Footer";
export default function OurGlobalReachPage() {
  return <div>
      <Navigation />
      <Network />
      <SupplyChain />
      <Logistics />
      <Footer />
    </div>;
}